import axios from 'axios/index';

export const GET_RINGKAS_ROMBEL = '[REKAP ROMBEL] GET RINGKAS ROMBEL';
export const GET_REKAP_LAMA_SEKOLAH = '[REKAP ROMBEL] GET REKAP LAMA SEKOLAH';

export function getRekapringkasan(routeParams)
{
    const request = axios.post(localStorage.getItem('api_base')+'/api/Rombel/Rekapringkasan', {
        ...routeParams
    });
    
    return (dispatch) =>
    request.then((response) =>
    {
        dispatch({
            type   : GET_RINGKAS_ROMBEL,
            payload: response.data,
            routeParams
        })
    });
}

export function getRls(routeParams)
{
    const request = axios.post(localStorage.getItem('api_base')+'/api/Rombel/getRls', {
        ...routeParams
    });
    
    return (dispatch) =>
    request.then((response) =>
    {
        dispatch({
            type   : GET_REKAP_LAMA_SEKOLAH,
            payload: response.data,
            routeParams
        })
    });
}